import { createSelector } from 'reselect';
import { AppState } from './reducer';

export const selectAppState = (state: any): AppState => {
  return state.app;
};

export const getAppStatus = createSelector(
  selectAppState,
  (appState: AppState) => {
    return appState.appStatus;
  },
);



// WEBPACK FOOTER //
// ./src/containers/App/selectors.ts